import type { FormScope } from '@rvf/react-router'
import { useControlField, useField } from '@rvf/react-router'
import { Checkbox, Label } from '~/components/ui'
import { cn } from '~/lib'

type CheckboxFieldProps = {
  className?: string
  label: string
  name: string
  disabled?: boolean
  defaultValue?: boolean
  showChangedRing?: boolean
  onBlur?: () => void
  onCheckedChange?: (value: string | boolean) => void
  scope?: FormScope<Record<string, any>>
}

export default function CheckboxField(props: CheckboxFieldProps) {
  const {
    className,
    name,
    label,
    disabled,
    defaultValue,
    showChangedRing,
    onBlur: customOnBlur,
    onCheckedChange,
    scope,
  } = props

  const { getInputProps, defaultValue: previousValue } = useField(name)
  const { onBlur } = getInputProps()
  const [value, setValue] = useControlField(name, scope)

  return (
    <div className={cn('flex items-center space-x-2', className)}>
      <Checkbox
        id={name}
        name={name}
        disabled={disabled}
        checked={typeof value !== 'undefined' ? !!value : defaultValue}
        onCheckedChange={(value) => {
          setValue(value.valueOf())
          onCheckedChange?.(value.valueOf())
          customOnBlur?.()
          onBlur?.()
        }}
        className={cn(
          showChangedRing &&
            previousValue &&
            value != previousValue &&
            'text-yellow-300 ring-2 ring-yellow-300 ring-offset-2'
        )}
      />
      <Label htmlFor={name} className="font-normal">
        {label}
      </Label>
    </div>
  )
}
